import { Navigate, useSearchParams } from 'react-router';
import { Loading, writeReturnTo } from '../../components.js';
import { useSession } from '../../session.js';
import { rememberSignupPlan } from './signup-plan.js';

/**
 * Entry from the public landing page (ADR 0027): `/start?plan=<code>` remembers the plan, then
 * goes to store creation, through sign-up when needed. The wizard of the new store chooses it.
 */
export function StartPage() {
  const [params] = useSearchParams();
  const { state } = useSession();
  // Before any redirect (idempotent: the same code is stored again on re-render).
  rememberSignupPlan(params.get('plan'));

  if (state.kind === 'loading') return <Loading />;
  if (state.kind === 'signed-in') return <Navigate to="/stores/new" replace />;
  writeReturnTo('/stores/new');
  return <Navigate to={state.kind === 'mfa-pending' ? '/mfa' : '/sign-in'} replace />;
}
